import { c as _c } from "react/compiler-runtime";
import { cn } from '@/lib/utils';
import type { ReactNode } from 'react';
interface IProps {
  children: ReactNode;
  className?: string;
  mobileReverse?: boolean;
}
const Child = t0 => {
  const $ = _c(5);
  const {
    children,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("w-full lg:w-1/2", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== children || $[3] !== t1) {
    t2 = <section className={t1}>{children}</section>;
    $[2] = children;
    $[3] = t1;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
const HalfLayout = t0 => {
  const $ = _c(6);
  const {
    children,
    className,
    mobileReverse: t1
  } = t0;
  const mobileReverse = t1 === undefined ? false : t1;
  const t2 = mobileReverse ? "flex-col-reverse" : "flex-col";
  let t3;
  if ($[0] !== className || $[1] !== t2) {
    t3 = cn("flex h-full justify-between gap-10 lg:flex-row", t2, className);
    $[0] = className;
    $[1] = t2;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== children || $[4] !== t3) {
    t4 = <div className={t3}>{children}</div>;
    $[3] = children;
    $[4] = t3;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
};
HalfLayout.displayName = 'HalfLayout';
HalfLayout.LeftChild = Child;
HalfLayout.RightChild = Child;
export default HalfLayout;